import { render, staticRenderFns } from "./FueraDeServicio.vue?vue&type=template&id=50d7a49e&scoped=true&"
import script from "./FueraDeServicio.vue?vue&type=script&lang=js&"
export * from "./FueraDeServicio.vue?vue&type=script&lang=js&"
import style0 from "./FueraDeServicio.vue?vue&type=style&index=0&id=50d7a49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d7a49e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VSheet})
